
import Button from '@material-ui/core/Button'
import Card from '@material-ui/Core/Card';
import React, { Component } from 'react';
import CardActions from '@material-ui/core/CardActions'
import { Popover, IconButton, Typography, CardContent} from '@material-ui/core'
import HelpIcon from '@material-ui/icons/Help';
import PopupState, { bindTrigger, bindPopover} from 'material-ui-popup-state'
import NavigateNext from '@material-ui/icons/NavigateNext'

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import NextButton from './nextButton'
import TableCheckbox from './answers/TableCheckbox'
import TableToggle from './answers/TableToggle'
import TableSlider from './answers/TableSlider'
import TableInput from './answers/TableInput'

import { withStyles } from '@material-ui/core/styles';


const styles = theme => ({
    root: {
        
    },
    header: {
        textAlign: 'center',
        marginBottom: '0px'
    },
    card: {
        padding: '0 1vw 1em 1vw'
    },
    center: {
        textAlign: 'center',
        justifyContent: 'center'
    },
    smallTitle: {
        fontSize: '1.3em'
    },
    regularTitle: {
        fontSize: '1.5em'
    }
});

class Clustered extends Component {
    constructor(props){
        super(props);
        this.state = {
            setCount: props.question.QuestionSetQuestions.length
        }
    }

    componentDidUpdate(prevProps) {
        //if(this.props.question.QuestionSetQuestions[0].QuestionStandardContent !== prevProps.question.QuestionSetQuestions[0].QuestionStandardContent){
        //    this.setState({answer: this.props.question.QuestionSetQuestions[0].Responses[0].Response})
        //}
    }

    changeAnswer = ev => {
        console.log(ev.target.value)
        //this.setState({answer: ev.target.value})
        //this.props.updateResponseValue(ev.target.value)
    }

    

    render() {
        const {classes} = this.props;
        let answertype = null;
        let nextbutton = null;
        //questions types word differently 

        if(this.props.question.QuestionSetQuestions[0] && this.props.question.QuestionSetQuestions[0].QuestionTypeKeyName == "CHECKBOX"){
            answertype = <Table size="small">
                            <TableBody>
                            {this.props.question.QuestionSetQuestions.map((question) => (
                                <TableCheckbox question={question} questionSetUpdateResponseValue={this.props.questionSetUpdateResponseValue.bind(this)}></TableCheckbox>
                            ))}
                            </TableBody>
                        </Table>
            nextbutton = <NextButton buttonLabel={this.props.buttonLabel} saveRemaining={this.props.saveRemaining.bind(this)} />

        }
        if(this.props.question.QuestionSetQuestions[0] && this.props.question.QuestionSetQuestions[0].QuestionTypeKeyName == "TOGGLE"){
            console.log("toggle")
            answertype = <Table size="small" padding="none">
                            <TableHead>
                                <TableRow>
                                    <TableCell></TableCell>
                                    <TableCell style={{paddingLeft:"0px", paddingRight:"0"}}></TableCell>
                                    {this.props.question.QuestionSetQuestions[0].Answers.map(answer => (
                                        <TableCell style={{paddingLeft:"9px", paddingRight:"0"}}>{answer.AnswerStandardContent}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                                
                            <TableBody>
                            {this.props.question.QuestionSetQuestions.map((question) => {
                                return question.QuestionDisplayedFlag == "1" ? 
                                <TableToggle question={question} questionSetUpdateResponseValue={this.props.questionSetUpdateResponseValue.bind(this)}></TableToggle>
                                : null
                            }
                                
        )}
                            </TableBody>
                        </Table>
        }
        if(this.props.question.QuestionSetQuestions[0] && this.props.question.QuestionSetQuestions[0].QuestionTypeKeyName == "SLIDER"){
            console.log("slider")
            answertype = <Table size="small" padding="none">
                                
                            <TableBody>
                            {this.props.question.QuestionSetQuestions.map((question) => (
                                <TableSlider question={question} questionSetUpdateResponseValue={this.props.questionSetUpdateResponseValue.bind(this)}></TableSlider>
                                
                                ))}
                            </TableBody>
                        </Table>
            nextbutton = <NextButton saveRemaining={this.props.saveRemaining.bind(this)} />
        }

        if(this.props.question.QuestionSetQuestions[0] && (this.props.question.QuestionSetQuestions[0].QuestionTypeKeyName == "DECIMAL INPUT" || this.props.question.QuestionSetQuestions[0].QuestionTypeKeyName == "INTEGER INPUT")){
            answertype = <Table size="small" padding="none">
                            <TableBody>
                            {this.props.question.QuestionSetQuestions.map((question) => {
                                return question.QuestionTypeKeyName === "DECIMAL INPUT" ? 
                                <TableInput question={question} questionSetUpdateResponseValue={this.props.questionSetUpdateResponseValue.bind(this)} validation={this.props.validationMessages} ></TableInput> :
                                <><TableRow>
                                    <TableCell></TableCell>
                                    <TableCell style={{paddingLeft:"0px", paddingRight:"0"}}></TableCell>
                                    {question.Answers.map(answer => (
                                        <TableCell style={{paddingLeft:"9px", paddingRight:"0"}}>{answer.AnswerStandardContent}</TableCell>
                                    ))}
                                </TableRow>
                                <TableToggle question={question} questionSetUpdateResponseValue={this.props.questionSetUpdateResponseValue.bind(this)}></TableToggle>
                                </>
                            })}
                            </TableBody>
                        </Table>
            nextbutton = <NextButton saveRemaining={this.props.saveRemaining.bind(this)} />
        }
        
        let helpIcon = null
        if(this.props.question.QuestionSetHelpText.length){
            helpIcon = <PopupState variant="popover" popupId="help-popover">
                    {popupState => (
                        <span style={{float:'right', width: '35px', top:'-15px', position:'relative'}}>
                            
                        <IconButton aria-label="additional help text" variant="contained"  {...bindTrigger(popupState)} style={{color:'rgba(0,0,0,0.54)', padding:'12px', borderRadius:'50%'}}>
                            <HelpIcon/>
                        </IconButton>
                        <Popover 
                            {...bindPopover(popupState)}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'center',
                                horizontal: 'right',
                            }}
                            >
                            <Typography style={{maxWidth:'330px', padding:'10px'}} dangerouslySetInnerHTML={{__html:this.props.question.QuestionSetHelpText}}></Typography>
                        </Popover>
                        </span>
                    )}
                </PopupState>
        }

        //font size based on content length or help icon
        let fontsize = '1.5em'
        if (this.props.question.QuestionSetQuestions[0].QuestionStandardContent.length >= 80 || this.props.question.QuestionSetQuestions[0].QuestionHelpText.length){
            fontsize = '1.3em'
        }

        return (
            <Card raised="true" style={{minHeight:'350px'}}>
                <div style={{display: 'inline-flex'}}>
                    <CardContent>
                        {helpIcon}
                        <Typography 
                            variant='h5' style={{fontSize: fontsize}}>
                            {this.props.question.QuestionSetStandardContent}
                        </Typography>

                    </CardContent>
                </div>
                
                <CardActions style={{display:'block', paddingLeft:'15px', paddingRight:'15px'}}>
                    {answertype}
                    
                    {nextbutton}
                </CardActions>
            </Card>
        )
    }
}
//<CardHeader title={this.props.question[0].QuestionStandardContent} titleTypographyProps={{fontSize: '25px'}}/>
export default Clustered;